import type { Dispatch, SetStateAction } from 'react';

export const handler = {
    text:
        <T>(key: keyof T, state: T, dispatch: Dispatch<SetStateAction<T>>) =>
        (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            const draft = { ...state, [key]: e.target.value };
            dispatch(draft);
        },
    checkbox:
        <T>(key: keyof T, state: T, dispatch: Dispatch<SetStateAction<T>>) =>
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const draft = { ...state, [key]: e.target.checked ? '1' : '0' };
            dispatch(draft);
        },
};
